import dayjs from "dayjs";
import { ISO_FORMAT } from "store/constants/date";

export const getDiffNights = (startDate = "", endDate = "") => {
  if (startDate === "" || endDate === "") return 0;
  const fromDate = dayjs(startDate);
  const toDate = dayjs(endDate);
  return toDate.diff(fromDate, "day");
};

export const getDayFormat = (date) =>
  Number(dayjs(date).format(ISO_FORMAT).split("-")[2].substr(0, 2)) < 10
    ? "D"
    : "DD";
